import { Messages } from '../../codegen/Localize';
import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { IContentInfo } from '../models/IContentInfo';
import { Module } from '../Module';
import { Databases } from '../resources/Databases';
import { Tables } from '../resources/Tables';
import { IResult } from '../ServerApi/types/IResponse';
import { ToasterService, ToastType } from '../services/ToasterService';
import { SearchSuggestionsService } from './SearchSuggestionsService';
import { openConfirmActionDialog } from './ReactConfirmActionDialog';
import { SetOwnerDialogBodyProps, SetOwnerDialogState, SetOwnerDialogBody } from '../../app/content/SetOwnerDialog';

export class ChangeExternalContentContactAction {

  public static $inject = [
    'Databases',
    'Tables',
    'SearchSuggestionsService'
  ];

  constructor(
    private Databases: Databases,
    private Tables: Tables,
    private suggestions: SearchSuggestionsService
  ) { }

  public confirmChangeContact(externalContentType: string, externalContentItem: IContentInfo, context: IActionContext): ng.IPromise<IResult> {

    let externalContentService: Databases | Tables;
    if (externalContentType === 'database') {
      externalContentService = this.Databases;
    } else {
      externalContentService = this.Tables;
    }

    let currentContactId: string = null;
    if (externalContentItem.contact) {
      currentContactId = externalContentItem.contact.id;
    }

    const modalInstance = openConfirmActionDialog<SetOwnerDialogBodyProps, SetOwnerDialogState, IResult>({
      title:  Messages.changeContact(),
      bodyComponent: SetOwnerDialogBody,
      initialBodyProps: {
        prompt: Messages.changeContactPrompt({ CONTENT_NAME: L10n.elideIfLong(externalContentItem.name) }),
        showCredentialsWarning: false,
        getQuery: (matchText: string) => this.suggestions.usersWithoutGuest(matchText)
      },
      initialDialogState: { targetOwner: null },
      actionName: Messages.changeContactConfirm(),
      action: (_bodyProps: SetOwnerDialogBodyProps, dialogState: SetOwnerDialogState) => {
        return externalContentService.setContact(({
          contactId: dialogState.targetOwner.id,
          contactType: 'User',
          ids: [externalContentItem.vizportalId],
        })).then((result: IResult) => {
          this.toast(result, Messages.changeContactError({ CONTENT_NAME: externalContentItem.name }),
          Messages.changeContactSuccess({ CONTACT_NAME: dialogState.targetOwner.displayName }));
          return result;
        });
      },
      actionDisabled: (_bodyProps: SetOwnerDialogBodyProps, dialogState: SetOwnerDialogState) => dialogState.targetOwner == null || dialogState.targetOwner.id === currentContactId,
    });

    return modalInstance.result;
  }

  private toast(result: IResult, errorMessage: string, successMessage: string): any {
    if (result.errors && result.errors.length > 0) {
      ToasterService.instance.pop({
        type: ToastType.Error,
        text: errorMessage
      });
    } else {
      ToasterService.instance.pop({
        type: ToastType.Info,
        text: successMessage
      });
    }
  }
}

Module.instance().service('ChangeExternalContentContactAction', ChangeExternalContentContactAction);
